import { Project } from "@/generated/graphql";

const getProjectActivitiesCount = (project: Project): string => {
  const activities = project.project_activities_aggregate.aggregate?.count;

  if (!activities) {
    return "0";

  }
  return String(activities);
}

export default getProjectActivitiesCount;